// Only the read-only ticket-status request may be retried after a transport
// failure. This module has no login/join/answer/photo POST capability.
export function waitForAdmissionDelay(ms, signal) {
  return new Promise((resolve, reject) => {
    const stop = () => {
      clearTimeout(timer);
      signal.removeEventListener("abort", stop);
      reject(new DOMException("Entrada cancelada", "AbortError"));
    };
    const timer = setTimeout(() => {
      signal.removeEventListener("abort", stop);
      resolve();
    }, ms);
    signal.addEventListener("abort", stop, { once: true });
    if (signal.aborted) stop();
  });
}

export function transientQueuePoll(error) {
  if (["AbortError", "CanceledError"].includes(error?.name) || error?.code === "ERR_CANCELED") return false;
  if ([502, 503, 504].includes(error?.response?.status)) return true;
  return !error?.response && error?.isAxiosError === true &&
    ["ERR_NETWORK", "ECONNABORTED", "ETIMEDOUT"].includes(error?.code);
}

export async function waitForQueueReady({ get, ticket, initialState, signal, onQueue,
  sleep = waitForAdmissionDelay, random = Math.random }) {
  if (typeof ticket !== "string" || !ticket || ticket.length > 100) throw new Error("Reserva de entrada inválida");
  let state = initialState;
  let failures = 0;
  let retrySeconds = 0;
  while (!signal.aborted) {
    if (!failures) onQueue?.(state);
    const seconds = Math.max(5, Math.min(30, Number(state.retry_after_seconds) || 5), retrySeconds);
    await sleep((seconds + random() * 3) * 1000, signal);
    if (signal.aborted) break;
    let poll;
    try {
      poll = await get("/admission/status", { signal, timeout: 10000,
        headers: { "X-Admission-Ticket": ticket } });
    } catch (error) {
      failures += 1;
      const retryAfter = Number(error?.response?.headers?.["retry-after"]) || 0;
      // Two retries, spaced 8–19 seconds. Never hammer the gateway, retry a
      // closed/expired ticket, ignore cancellation or shorten a long Retry-After.
      if (signal.aborted || !transientQueuePoll(error) || failures >= 3 || retryAfter > 30) throw error;
      retrySeconds = Math.max(8 * failures, retryAfter);
      onQueue?.({ ...state, reconnecting: true,
        message: "Oscilação de conexão. Mantendo seu lugar e consultando novamente…" });
      continue;
    }
    if (poll.status !== 200 || !["admission_queued", "admission_ready"].includes(poll.data?.status)) {
      throw new Error("Resposta inválida ao consultar a fila");
    }
    state = poll.data;
    failures = 0;
    retrySeconds = 0;
    if (state.status === "admission_ready") return state;
  }
  throw new DOMException("Entrada cancelada", "AbortError");
}
